"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useBaseAnimationStyles", {
    enumerable: true,
    get: function() {
        return useBaseAnimationStyles;
    }
});
const _react = require("@griffel/react");
const useBaseAnimationStyles = /*#__PURE__*/ (0, _react.__resetStyles)("r16zaflb", "r75casi", [
    ".r16zaflb{animation-name:rsacmq1;}",
    "@keyframes rsacmq1{from{opacity:0;}to{opacity:0;}}",
    ".r75casi{animation-name:rsacmq1;}"
]); //# sourceMappingURL=useTimerStyles.styles.js.map
